<template>
  <el-container style="border: 1px solid #eee" class="outer">
    <el-main>
      <el-tabs v-model="activeTab">
        <!-- Manage Roles -->
        <el-tab-pane name="roles" label="Roles">
          <TabRoles />
        </el-tab-pane>

        <!-- Manage Departments -->
        <el-tab-pane name="department" label="Departments">
          <TabDepartments />
        </el-tab-pane>

        <!-- Manage Users -->
        <!-- Disable user tab in case of keycloak -->
        <el-tab-pane v-if="notKeycloakAuth" name="users" label="Users">
          <!-- Dialog for Add new Auth0 user -->
          <TabUsers :is-fetching-users="isFetchingUsers" :refreshUsers="fetchUsers" />
        </el-tab-pane>
        <!-- <el-tab-pane name="activeusers" label="Active Users">
          <TabActiveUsers v-if="activeTab === 'activeusers'" />
        </el-tab-pane> -->
      </el-tabs>
    </el-main>
  </el-container>
</template>
<script>
import TabRoles from "./TabRoles/Index";
import TabUsers from "./TabUsers/Index";
import TabDepartments from "./TabDepartments/Index";
import { getAuthType } from "@/auth";

export default {
  components: {
    TabRoles,
    TabUsers,
    TabDepartments,
  },
  data() {
    return {
      activeTab: "roles",
      isFetchingDepartments: false,
      isFetchingUsers: false,
    };
  },
  methods: {
    fetchUsers(page = 1, size = 20, search = "", order = 1) {
      this.isFetchingUsers = true;
      this.$store
        .dispatch("FETCH_AUTH_USERS", {
          page: page - 1, size, search, order,
        })
        .catch((err) => {
          this.$notify.error({
            title: "Fetch Error",
            message: "Encountered error fetching auth users",
            position: "bottom-right",
          });
        })
        .finally(() => (this.isFetchingUsers = false));
    },
    fetchDepartments() {
      this.$store
        .dispatch("FETCH_DEPARTMENTS")
        .catch((err) => {
          this.$notify.error({
            title: "Fetch Error",
            message: "Encountered error fetching departments",
            position: "bottom-right",
          });
        })
        .finally(() => (this.isFetchingDepartments = false));
    },
  },
  mounted() {
    this.fetchUsers();
    this.fetchDepartments();
  },
  computed: {
    notKeycloakAuth() {
      return getAuthType() !== "KEYCLOAK";
    },
  },
};
</script>
